(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/app.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/app.js');
'use strict';

const {
  PlayerRouter,
  Route
} = svs.app.ReactRouter;
const {
  PlayerRegistrationReduxProvider
} = svs.playerRegistration.store;
const {
  routes
} = svs.playerRegistration.constants;
const {
  baseUrl
} = svs.core.data;
const {
  ErrorBoundary
} = svs.components.errorBoundary;
const {
  ScrollTopOnNav
} = svs.tb_ui_react.scrollTop;
const {
  SetDepositLimits
} = svs.playerRegistration.pages.depositLimits;
const {
  Register
} = svs.playerRegistration.pages.register;
const {
  AccountCreated
} = svs.playerRegistration.pages.accountCreated;
const {
  Kyc
} = svs.playerRegistration.pages.kyc;
const {
  Deposit
} = svs.playerRegistration.pages.deposit;
const {
  Rejected
} = svs.playerRegistration.pages.rejected;
const {
  HeaderLogo,
  AnimatedColumns
} = svs.playerRegistration.components;
const {
  useStatusBarColor
} = svs.components.tb_ui_react.useStatusBarColor;
const PlayerRegistrationApp = () => {
  useStatusBarColor('player-registration-header');
  return React.createElement(PlayerRouter, {
    basename: baseUrl,
    className: "bg-white",
    withRouter: true
  }, React.createElement(ErrorBoundary, null, React.createElement(PlayerRegistrationReduxProvider, null, React.createElement(HeaderLogo, null), React.createElement(ScrollTopOnNav, null, React.createElement("div", null, React.createElement(Route, {
    exact: true,
    path: routes.HOME,
    render: () => React.createElement(Register, null)
  }), React.createElement(Route, {
    exact: true,
    path: routes.ACCOUNT_CREATED,
    render: () => React.createElement(AccountCreated, null)
  }), React.createElement(Route, {
    exact: true,
    path: routes.DEPOSIT_LIMITS,
    render: () => React.createElement(SetDepositLimits, null)
  }), React.createElement(Route, {
    exact: true,
    path: routes.KYC,
    render: () => React.createElement(Kyc, null)
  }), React.createElement(Route, {
    exact: true,
    path: routes.KYC_RESUME,
    render: () => React.createElement(Kyc, null)
  }), React.createElement(Route, {
    exact: true,
    path: routes.DEPOSIT,
    render: () => React.createElement(Deposit, null)
  }), React.createElement(Route, {
    exact: true,
    path: routes.REJECTED,
    render: () => React.createElement(Rejected, null)
  }), React.createElement(Route, {
    exact: true,
    path: routes.ANIMATION,
    render: () => React.createElement(AnimatedColumns, null)
  }))))));
};
svs.playerRegistration.PlayerRegistrationApp = PlayerRegistrationApp;

 })(window);